import StandardPage from "~/containers/StandardPage";
import HeaderNoProfile from "~/molecules/headers/HeaderNoProfile";
import SessionProvider from "~/providers/SessionProvider";
import FourOhFour from "~/templates/FourOhFour";

const NotFoundPage = () => {
  return (
    <>
      <HeaderNoProfile />
      <main className="my-10 pb-10">
        <StandardPage>
          <SessionProvider>
            <FourOhFour />
          </SessionProvider>
        </StandardPage>
      </main>
    </>
  );
};

export default NotFoundPage;
